import { render, staticRenderFns } from "./AraciHizmetSaglayicilar.vue?vue&type=template&id=5c97c6a2&scoped=true&"
import script from "./AraciHizmetSaglayicilar.vue?vue&type=script&lang=js&"
export * from "./AraciHizmetSaglayicilar.vue?vue&type=script&lang=js&"
import style0 from "./AraciHizmetSaglayicilar.vue?vue&type=style&index=0&id=5c97c6a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c97c6a2",
  null
  
)

export default component.exports